<template>
  <b-overlay
    :show="showOver"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <b-row class="match-height">
        <div class="text-center">
          <p id="cancel-label">
            กรุณารอสักครู่...
          </p>
        </div>
      </b-row>
    </template>
    <!-- <this-header /> -->
    <div class="anan-set-nav-conttainer ">
      <div class="col-md-12 mb-2">
        <div>
          <router-link :to="{name : 'admin-lost-package'}">
            <b-button
              variant="primary"
              class="mr-50 col-md-2"
            >
              {{ $t('returnToList') }}
            </b-button>
          </router-link>
        </div>
      </div>

      <b-row class="match-height">
        <div class="row d-flex">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div>
              <div class="card p-2">
                <h4 class="font-weight-bolder mb-1">
                  {{ $t('details') }} {{ items.itemnumber_text }}
                  <hr>
                </h4>

                <div>
                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-right mr-2">
                        {{ $t('orderNumber') }}
                      </p>
                    </div>

                    <div class="w-50">
                      {{ items.itemnumber_text }}
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-right mr-2">
                        {{ $t('orderList') }}
                      </p>
                    </div>

                    <div class="w-50">
                      <router-link :to="{name : 'admin-order-detail', params: {id: items.order_id} }">
                        {{ items.order_text }}
                      </router-link>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-right mr-2">
                        {{ $t('transactionDate') }}
                      </p>
                    </div>

                    <div class="w-50">
                      {{ time(items.created_at) }}
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-right mr-2">
                        {{ $t('mnemonic') }}
                      </p>
                    </div>

                    <div class="">
                      {{ items.remark_cus }}
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-right mr-2">
                        {{ $t('remarks') }}
                      </p>
                    </div>

                    <div class="">
                      <b-form-textarea
                        id="h-address"
                        v-model="items.note"
                        type="text"
                        @change="submit()"
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="card">
              <div class="header-cardx p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h4 class="font-weight-bolder">
                    {{ $t('relatedAmountList') }}
                  </h4>
                </div>

                <table class="styled-table mt-n25">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('transactionDate') }}
                      </th>
                      <th
                        class="text-center"
                        scope="col"
                      >
                        {{ $t('details') }}
                      </th>
                      <th scope="col">
                        {{ $t('quantity') }}
                      </th>
                    </tr>
                  </thead>
                  <thead>
                    <tr
                      v-for="(item,index) in Transaction"
                      :key="index"
                      style="background: #fff; color: black;"
                    >
                      <th
                        class="text-center"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        {{ time(item.created_at) }}
                        <!-- 09 ตุลาคม 2023 13:16:12 -->
                      </th>
                      <th
                        class="text-left"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        {{ item.detail }}
                        <!-- รายการชำระค่านำเข้า PAY-10727 -->
                      </th>
                      <th
                        class="text-right"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        <span :style="getAmountStyle(item.type, item.type_amount)">
                          {{ getAmountPrefix(item.type, item.type_amount) }} {{ Commas(item.amount.toFixed(2)) }} ฿
                        </span>
                        <!-- {{ item.amount }} -->
                        <!-- -9.00 ฿ -->
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="d-flex align-items-center justify-content-start p-2" />
              </div>
            </div>

          </div>

        </div>
      </b-row>
      <b-row class="match-height">
        <div class="row d-flex">
          <b-col class="col-md-6 col-lg-6 col-sm-12">
            <div class="card">
              <div class="header-cardx p-2">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="font-weight-bolder">
                    {{ $t('attachmentList') }}
                  </h4>
                </div>
              </div>
              <div class="p-2">
                <div class="col-md-8">
                  <span
                    v-for="ItImg in items.fileimg"
                    :key="ItImg"
                    class="aws-avatar aws aws-avatar-square aws-avatar-image bordered cursor-pointer"
                  >
                    <img
                      :src="GetImg('lostpackage_file',ItImg)"
                      alt="asd"
                      class="rounded mr5"
                      @click="showPicture(ItImg)"
                    >

                    <vue-image-lightbox-carousel
                      ref="lightbox"
                      :show="showLightbox"
                      :images="images"
                      :show-caption="false"
                      @close="closeBox()"
                    />
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-start p-2" />
              <div class="d-flex align-items-center justify-content-start p-2" />
            </div>

          </b-col>

          <b-col class="col-md-6 col-lg-6 col-sm-12">
            <div class="card">
              <div class="header-cardx p-2">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="font-weight-bolder">
                    {{ $t('key-28') }}
                  </h4>
                </div>
              </div>
              <div class="p-2">
                <div class="col-md-12">
                  <!-- <hr> -->
                  <!-- <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-left mr-2">
                        {{ $t('details') }}
                      </p>
                    </div>

                    <div class="w-100 mr-5">
                      <b-form-input
                        v-model="wrecord"
                        type="text"
                      />
                    </div>
                    <b-button
                      variant="success"
                      class="btn btn-success mr-1"
                      @click="RecordSubmit()"
                    >
                      {{ $t('save') }}
                    </b-button>
                  </div>
                  <hr> -->
                  <table class="styled-table mt-n25">
                    <thead>
                      <tr>
                        <th scope="col">
                          {{ $t('transactionDate') }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                        >
                          {{ $t('details') }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                        >
                          {{ $t('transactionEvidence') }}
                        </th>

                        <th scope="col">
                          {{ $t('addedBy') }}
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr
                        v-for="(item,index) in items.record"
                        :key="index"
                        style="background: #fff; color: black;"
                      >
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >

                          {{ item.created_at }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ item.detail }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          <span
                            v-for="data of item.record_img"
                            :key="data"
                          >
                            <img
                              :src="GetImg('lostpackage_file',data)"
                              alt="asd"
                              width="50px"
                              height="50px"
                              class="rounded mr5"
                              @click="showPicture(data)"
                            >

                          <!-- <vue-image-lightbox-carousel
                            ref="lightbox"
                            :show="showLightbox"
                            :images="images"
                            :show-caption="false"
                            @close="closeBox()"
                          /> -->
                          </span>
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ item.add_by }}
                        </th>
                      </tr>
                    </thead>

                  </table>
                  <hr>
                  <div class="d-flex align-items-center mb-1">
                    <div class="w-50">
                      <p class="mb-0 font-weight-bolder text-left mr-2">
                        {{ $t('details') }}
                      </p>
                    </div>

                    <div class="w-100 mr-2">
                      <b-form-input
                        v-model="wrecord"
                        type="text"
                      />
                    </div>

                    <b-button
                      class="btn btn-danger mr-1"
                      @click="clickFileInput"
                    >
                      +
                      <input
                        id="img-file"
                        ref="fileInput"
                        type="file"
                        class="input-file"
                        accept="image/*"
                        multiple
                        style="display: none;"
                        @change="handleFileChanges($event)"
                      >
                    </b-button>
                    <b-button
                      variant="success"
                      class="btn btn-success mr-1"
                      @click="RecordSubmit()"
                    >
                      <!--  -->
                      {{ $t('save') }}
                    </b-button>

                  </div>
                  <div class="od-pc-offer-price-common ml-3">
                    <div
                      v-if="record_img.length"
                      class="image-row"
                    >
                      <span
                        v-for="(item, index) in record_img"
                        :key="index"
                        class="image-container"
                      >
                        <img
                          class="responsive"
                          width="50"
                          height="50"
                          :src="item"
                          :alt="item"
                          @click="showPicture64(record_img)"
                        >
                        <br>
                        <!-- <span> -->
                        <b-button
                          variant="danger"
                          class="btn btn-success mr-0 mt-1"
                          width="10px"
                          height="10px"
                          @click="Picture64delete(index)"
                        >
                          <!-- @click="RecordSubmit()" -->
                          {{ $t('delete') }}
                        </b-button>
                      <!-- </span> -->
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </b-col>
        </div>
      </b-row>

      <b-row class="match-height">
        <div class="d-flex">
          <b-col class="col-md-12">
            <div class="card">
              <div class="header-cardx p-2">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="font-weight-bolder">
                    {{ $t('key-29') }}
                  </h4>
                </div>
              </div>
              <div class="table-container">
                <table class="styled-table mt-n25">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('sequence') }}
                      </th>
                      <th
                        class="text-left w-50"
                        scope="col"
                      >
                        {{ $t('details') }}
                      </th>
                      <th
                        scope="col"
                        class="w-30"
                      >
                        {{ $t('approvalDate') }}
                      </th>
                      <th
                        scope="col"
                        class="w-15"
                      >
                        {{ $t('Refunds') }} ¥
                      </th>

                      <th
                        scope="col"
                        class="w-25"
                      >
                        {{ $t('manage') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(arritem,index) in items.detail"
                      :key="index"
                      style="background: #fff; color: black;"
                    >

                      <th
                        class="text-center"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        {{ index+1 }}.
                      </th>
                      <td
                        class="text-left"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        {{ arritem.detail }}
                      </td>
                      <td
                        class="text-center"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        {{ arritem.approvalDate ? time(arritem.approvalDate) : '-' }}
                        <!-- ¥ {{ Commas(arritem.balance) }} -->

                      </td>
                      <td
                        class="text-center"
                        scope="col"
                        style="background: #fff; color: black;"
                      >
                        <div
                          v-if="arritem.check_balance == 1"
                          class="d-flex align-items-center justify-content-center"
                        >
                          ¥
                          <b-form-input
                            v-model.number="arritem.balance"
                            type="number"
                            min="0"
                            step="0.01"
                            class="text-center ml-50"
                            style="max-width: 120px;"
                            @change="submitBalance()"
                          />
                        </div>
                        <span v-else>
                          ¥ {{ Commas(arritem.balance) }}
                        </span>
                      </td>
                      <td
                        v-if="arritem.check_balance == 1"
                        class="text-center "
                        scope="col "
                        style="background: #fff; color: black;"
                      >

                        <button
                          class="btn btn-danger"
                          style="font-size: 10px;"
                          @click="canceldata(arritem)"
                        >{{
                          $t('cancel') }}</button>
                        <button
                          class="btn btn-success ml-lg-1 ml-sm-0 mt-1 mt-lg-0"
                          style="font-size: 10px;"
                          @click="Submitpay(arritem)"
                        >{{
                          $t('key-30') }}</button>

                      </td>
                      <td
                        v-if="arritem.check_balance == 2"
                        class="text-center "
                        scope="col "
                        style="background: #fff; color: black;"
                      >

                        <span class="w-50 badge badge-light-success col-md-6">{{ $t('operationCompleted') }}</span>

                      </td>
                      <td
                        v-if="arritem.check_balance == 3"
                        class="text-center "
                        scope="col "
                        style="background: #fff; color: black;"
                      >

                        <span
                          class="w-50 badge badge-light-secondary col-md-6 text-black"
                          style="font-size: 12px;"
                        >{{
                          $t('cancelled') }}<span
                          v-if="arritem.remark_cancel"
                          class="col-md-2 badge-light-danger text-danger"
                        >*{{ arritem.remark_cancel }}</span></span>

                      </td>
                    </tr>
                  </tbody>
                  <tfoot class="text-center">
                    <tr>
                      <th
                        colspan="3"
                        class="text-right font-weight-bolder"
                      >
                        {{ $t('yuanAmount') }}
                      </th>

                      <th
                        colspan="1"
                        class="text-center"
                      >
                        ¥ {{ Commas(items.detail.reduce((total,item) => total + item.balance,0)) }}
                      </th>
                    </tr>
                    <tr>
                      <th
                        colspan="3"
                        class="text-right font-weight-bolder"
                      >
                        {{ $t('key-31') }}
                      </th>

                      <th
                        colspan="1"
                        class="text-center"
                      >
                        {{ Commas(items.rate_yuan) }}
                      </th>
                    </tr>
                    <tr>
                      <th
                        colspan="3"
                        class="text-right font-weight-bolder"
                      >
                        {{ $t('key-32') }}
                      </th>

                      <th
                        colspan="1"
                        class="text-center"
                      >
                        {{ Commas(items.detail.reduce((total,item) => total + (item.balance* items.rate_yuan),0)) }} ฿
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </b-col>
        </div>
      </b-row>
    </div>
    <b-modal
      id="modal-cliam"
      :title="$t('remarks')"
      :ok-title="$t('save')"
      :cancel-title="$t('cancel')"
      @ok="submitAddNew()"
    >

      <b-form-group>
        <!-- <validation-provider
            #default="{ errors }"
            name="detail"
            rules="required"
          > -->
        <label for="claim_detail">{{ $t('details') }} :</label>
        <b-form-textarea
          id="claim_detail"
          v-model="remark_cancel"
          :placeholder="$t('remarks')"
        />
        <!-- :state="errors.length > 0 ? false:null" -->
        <!-- <span class="text-danger">{{ errors[0] ? $t('key-24'): '' }}</span> -->
        <!-- </validation-provider> -->
      </b-form-group>

    </b-modal>
  </b-overlay>

</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone'
import {
  BButton, BFormTextarea, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
// import ThisHeader from '@/views/customer/component/ThisHeader.vue'

export default {
  components: {
    BButton,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    VueImageLightboxCarousel,
    // ThisHeader,
  },
  data() {
    return {
      images: [],
      showLightbox: false,
      showOver: false,
      required,
      wrecord: null,
      items: [],
      Transaction: [],
      Detail: [
        { sequence: 1, detail: 'test', amount: 0 },
      ],
      ID: this.$route.params.id,
      record: [{
        type: 1, amount: 1000, created_at: '2021-10-10 10:10:10', detail: 'test',
      }],
      cancel_details: null,
      created_at: null,
      remark_cancel: null,
      record_img: [],
      ImgData: ['data:image/jpeg;base64,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'],
    }
  },
  mounted() {
    this.getData()
    this.getTransaction()
    // this.getgeneral()
  },
  methods: {
    clickFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileChanges(event) {
      const { files } = event.target
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          if (file.type.startsWith('image/')) {
            const blob = new Blob([file], { type: file.type })
            const reader = new FileReader()
            reader.onload = event => {
              this.record_img.push(event.target.result)
            }
            reader.readAsDataURL(blob)
          } else {
            console.log('ไฟล์ที่เลือกไม่ใช่รูปภาพ:', file)
          }
        }
      }
    },
    time(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    },
    async getData() {
      try {
        const params = {
          id: this.ID,
        }
        const { data: res } = await this.$http.get('/LostPackage/getDatacusOne', { params })
        this.items = res
        // console.log(res)
      } catch (e) {
        this.SwalError(e)
      }
    },
    async getTransaction() {
      try {
        const params = {
          id: this.ID,
        }
        const { data: res } = await this.$http.get('/LostPackage/getTransaction', { params })
        this.Transaction = res
      } catch (err) {
        this.SwalError(err)
      }
    },
    // async getgeneral() {
    //   try {
    //     const { data: res } = await this.$http.get('/general/show?agent_id=1')
    //     this.general = res.data.rate_import
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
    RecordSubmit() {
      if (!this.wrecord) {
        return
      }
      this.$bvModal.msgBoxConfirm('บันทึกการทำงานหรือไม่ ?', {
        title: 'ยืนยันข้อมูล',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.created_at = this.time(new Date())
          const obj = {
            id: this.ID,
            wrecord: this.wrecord,
            created_at: this.created_at,
            record_img: this.record_img,
          }
          this.$http.post('LostPackage/Updaterecord', obj)
            .then(() => {
              this.getData()
              this.Success(this.$t('key-260'))
              this.getTransaction()
              this.wrecord = null
              this.created_at = null
              this.record_img = []
            })
            .catch(err => {
              this.SwalError(err)
            })
        }
      })
    },
    getAmountStyle(amount, typeAmount) {
      if (amount === 21) {
        if (typeAmount) {
          return { color: 'green' }
        }
        return { color: 'red' }
      }
      if ([1, 8, 11, 12, 17, 16].includes(amount)) {
        return { color: 'green' }
      }
      if ([2, 3, 4, 5, 6, 7, 13, 15, 18, 10, 9, 20].includes(amount)) {
        return { color: 'red' }
      }
    },
    getAmountPrefix(value, typeAmount) {
      if (value === 21) {
        if (typeAmount) {
          return '+'
        }
        return '-'
      }
      if ([1, 8, 11, 12, 17, 16].includes(value)) {
        return '+'
      }
      if ([2, 3, 4, 5, 6, 7, 13, 15, 18, 10, 9, 20].includes(value)) {
        return '-'
      }
    },
    canceldata(data) {
      this.$swal({
        title: `<h3 style="color: #141414">ต้องการยกเลิกรายการ ยอด ¥ ${data.balance} </h3>`,
        icon: 'warning',
        showCancelButton: true,
        text: 'คุณต้องการยกเลิกรายการหรือไม่ ?',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
      }).then(result => {
        if (result.value) {
          this.$bvModal.show('modal-cliam')
          // eslint-disable-next-line no-underscore-dangle
          this.cancel_details = {
            id: data._id,
            ID: this.items._id,
            check_balance: 3,
            remark_cancel: null,
          }
          // this.getTracking()
          // this.$swal({
          //   icon: 'success',
          //   title: '<h3 style="color: #141414">สำเร็จ</h3>',
          //   html: '<p style="color: #141414">ทำรายการเคลมสินค้าสำเร็จ</p>',
          //   showConfirmButton: false,
          //   timer: 1500,
          // })
        } else {
          this.cancel_details = null
        }
      })
      // this.$bvModal.msgBoxConfirm(`ต้องการยกเลิกรายการ ยอด ¥ ${data.balance} ?`, {
      //   title: 'ยืนยันข้อมูล',
      //   size: 'sm',
      //   buttonSize: 'sm',
      //   okVariant: 'danger',
      //   okTitle: 'YES',
      //   cancelTitle: 'NO',
      //   footerClass: 'p-2',
      //   hideHeaderClose: false,
      //   centered: true,
      // }).then(value => {
      //   if (value) {
      //     const obj = {
      //       // eslint-disable-next-line no-underscore-dangle
      //       id: data._id,
      //       // eslint-disable-next-line no-underscore-dangle
      //       ID: this.items._id,
      //       check_balance: 3,
      //     }
      //     this.$http.post('/LostPackage/updatestatus', obj)
      //       .then(() => {
      //         this.getData()
      //         this.Success('ยกเลิกเรียบร้อยแล้ว')
      //       })
      //       .catch(err => {
      //         this.SwalError(err)
      //       })
      //   }
      // })
    },
    submitAddNew() {
      if (this.cancel_details) {
        this.cancel_details.remark_cancel = this.remark_cancel
        this.$http.post('/LostPackage/updatestatus', this.cancel_details)
          .then(() => {
            this.getData()
            this.Success('ยกเลิกเรียบร้อยแล้ว')
            this.remark_cancel = null
            this.cancel_details = null
          })
          .catch(err => {
            this.SwalError(err)
            this.remark_cancel = null
            this.cancel_details = null
          })
      }
    },
    timeapp(data) {
      return moment(data).format('YYYY-MM-DD HH:mm:ss')
    },
    Submitpay(data) {
      this.$bvModal.msgBoxConfirm(`คืนเงิน ยอด ¥ ${data.balance}?`, {
        title: 'ยืนยันข้อมูล',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          const obj = {
            detail: data,
            // eslint-disable-next-line no-underscore-dangle
            id: this.items._id,
            approvalDate: this.timeapp(new Date()),
          }
          this.$http.post('/LostPackage/updateandpay', obj)
            .then(() => {
              this.getData()
              this.Success('คืนเงินเรียบร้อย')
              this.getTransaction()
            })
            .catch(err => {
              this.SwalError(err)
            })
        }
      })
    },
    submit() {
      const obj = {
        // eslint-disable-next-line no-underscore-dangle
        id: this.items._id,
        note: this.items.note,
      }
      this.$http.post('/LostPackage/updateData', obj)
        .then(() => {
          this.Success('อัพเดทข้อมูลสำเร็จ')
          this.getData()
          this.getTransaction()
        }).catch(err => {
          this.SwalError(err)
        })
    },
    submitBalance() {
      const obj = {
        // eslint-disable-next-line no-underscore-dangle
        id: this.items._id,
        detail: this.items.detail,
      }
      this.$http.post('/LostPackage/updateData', obj)
        .then(() => {
          this.Success('อัพเดทข้อมูลสำเร็จ')
          this.getData()
          this.getTransaction()
        }).catch(err => {
          this.SwalError(err)
        })
    },
    GetImg(pathfile, filename) {
      return `${this.$http.defaults.baseURL}/viewimg?pathfile=${pathfile}/${filename}`
    },
    Picture64delete(index) {
      this.record_img.splice(index, 1)
    },
    showPicture(picture) {
      this.showLightbox = true
      const img = { path: this.GetImg('lostpackage_file', picture) }
      this.images.push(img)
      // this.$swal({
      //   imageUrl: picture,
      //   imageWidth: 400,
      //   imageHeight: 400,
      //   imageAlt: 'Custom image',
      //   confirmButtonText: 'ปิด',
      // })
    },
    showPicture64(picture) {
      this.showLightbox = true
      picture.forEach(picture => {
        const img = { path: picture }
        this.images.push(img)
      })
      // this.$swal({
      //   imageUrl: picture,
      //   imageWidth: 400,
      //   imageHeight: 400,
      //   imageAlt: 'Custom image',
      //   confirmButtonText: 'ปิด',
      // })
    },
    closeBox() {
      this.showLightbox = false
      this.images = []
    },
    Alert(status, title, mes) {
      this.$swal({
        icon: `${status ? 'success' : 'error'}`,
        title: `<h3 style="color: #141414">${title}</h3>`,
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        // title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: `<h3 style="color: #141414">${this.$t('key-298')}</h3>`,
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
    showModal(data) {
      this.pic = data
      this.$refs['my-modal'].show()
    },
    downloadImg() {
      const imageURL = '@/assets/images/anan-img/example/1.jpg'
      const link = document.createElement('a')
      link.href = imageURL
      link.download = 'image.jpg'
      link.click()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.od-pc-offer-price-common .image-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px; /* ระยะห่างด้านซ้าย */
  margin-right: -5px; /* ระยะห่างด้านขวา */
}

.od-pc-offer-price-common .image-container {
  flex: 0 0 calc(5% - 10px); /* กำหนดความกว้างของภาพให้เป็น 20% ของพื้นที่ของแถว และหักค่า margin ด้วย */
  padding: 0 5px; /* ระยะห่างด้านซ้ายและขวาของแต่ละภาพ */
}

.od-pc-offer-price-common .image-container img {
  width: 100%;
  height: auto;
}

</style>
